import ParameterValidator from '@mvps-genesis/parameter-validator';
import TabbedCarousel from './TabbedCarousel';

/*
 *--------------------------------------------------------------------------
 * Tabbed Carousels
 *--------------------------------------------------------------------------
 */
export default class TabbedCarousels {

	/**
	 * Parameter Validator object
	 *
	 * @var	@mvps-genesis/parameter-validator	ParameterValidator
	 */
	#validator;

	constructor (elements) {

		this.#validator = new ParameterValidator(this);

		this.elements = this.#validator.isElementList('element', elements);
		this.index = 0;

		this.init();

	}

	init () {

		for (const element of this.elements) {

			new TabbedCarousel(element);

		}

	}

}
